import React from 'react';
import { Button } from '@pushpay/button';
import { BurgerMenuIcon, CrossIcon } from '@pushpay/iconography';
import { clsx, createUseStyles } from '@pushpay/styles';
import { forwardRef } from '@pushpay/types';
const buttonSize = '40px';
const iconSize = '24px';
const useStyles = createUseStyles(theme => ({
  root: {
    width: buttonSize,
    height: buttonSize,
    fontSize: iconSize,
    borderRadius: theme.SHAPE.CIRCULAR,
    color: theme.colors['palette-grey-dark-200'],
    '&:hover': {
      color: theme.colors['color-text-default'],
      backgroundColor: theme.colors['palette-grey-light-300']
    },
    '&:focus': {
      color: theme.colors['color-text-default'],
      backgroundColor: theme.colors['palette-grey-light-300']
    }
  },
  icon: {}
}));
export const MobileMenuButton = forwardRef(function MobileMenuButton({
  label,
  isMenuOpen,
  onClick,
  classes: classesProp,
  className: classNameProp,
  'data-pp-at-target': targetId,
  ...rest
}, ref) {
  const classes = useStyles(classesProp);
  const className = clsx(classes.root, classNameProp);
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    ref: ref,
    type: "button",
    "aria-label": label,
    onClick: onClick,
    className: className,
    "data-pp-at-target": targetId
  }, rest), isMenuOpen ? /*#__PURE__*/React.createElement(CrossIcon, {
    "data-pp-at-target": `${targetId}-mobile-close-menuIcon`
  }) : /*#__PURE__*/React.createElement(BurgerMenuIcon, {
    "data-pp-at-target": `${targetId}-mobile-menuIcon`
  }));
});